// DictionariesPage — admin-справочники `/admin/dictionaries` (V16 W11, RoleGuard admin).
// Вкладки «Причины» | «Валюты»; канон TeamPage (PageHeader + Tabs).

import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { PageHeader } from '@/theme/PageHeader';
import { t } from '@/i18n';
import { RejectionReasonsTab } from './RejectionReasonsTab';
import { CurrenciesTab } from './CurrenciesTab';

/** Идентификатор вкладки справочников. */
type DictionaryTab = 'reasons' | 'currencies';

/** Страница admin-справочников: причины отказа и валюты. */
export function DictionariesPage(): JSX.Element {
  const [tab, setTab] = useState<DictionaryTab>('reasons');

  return (
    <Box>
      <PageHeader title={t('dict.title')} subtitle={t('dict.subtitle')} />
      <Tabs
        value={tab}
        onChange={(_, value: DictionaryTab) => setTab(value)}
        data-testid="dict-tabs"
        sx={{ mb: 2 }}
      >
        <Tab
          value="reasons"
          label={t('dict.tabs.reasons')}
          data-testid="dict-tab-reasons"
        />
        <Tab
          value="currencies"
          label={t('dict.tabs.currencies')}
          data-testid="dict-tab-currencies"
        />
      </Tabs>
      {tab === 'reasons' ? <RejectionReasonsTab /> : <CurrenciesTab />}
    </Box>
  );
}
